export default __webpack_public_path__ + "static/media/eye_icon_purple.7093ad57.svg";